// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"00e1bfe4","513":"b1307ba3","703":"eb9988dd"}[chunkId] + ".chunk.js";
};